export default (getPanelState) => {

    const getAssignedUsers = (state) => getPanelState(state).assignedUsers
    const getAssignedManagers = (state) => getPanelState(state).assignedManagers
    const canModifyAnyUser = (state) => getPanelState(state).canModifyAnyUser
    const canModifyAnyManager = (state) => getPanelState(state).canModifyAnyManager

    return {
        getAssignedUsers,
        getAssignedManagers,
        canModifyAnyUser,
        canModifyAnyManager,
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/selectorsGenerator.js